interface CategoryMap {
  [category: string]: {
    images: string[];
  };
}

export const categoryMap: CategoryMap = {
  anime: {
    images: [
      "https://files.idyllic.app/files/static/6124467", // Anime1
      "https://files.idyllic.app/files/static/6124475", // Anime2
      "https://files.idyllic.app/files/static/6124479", // Anime3
      "https://files.idyllic.app/files/static/6124482", // Anime4
      "https://files.idyllic.app/files/static/6124484", // Anime5
      "https://files.idyllic.app/files/static/6124488", // Anime6
      "https://files.idyllic.app/files/static/6124489", // Anime7
      "https://files.idyllic.app/files/static/6124490", // Anime8
      "https://files.idyllic.app/files/static/6124491", // Anime9
      "https://files.idyllic.app/files/static/6152428", // Anime11
      "https://files.idyllic.app/files/static/6152429", // Anime12
      "https://files.idyllic.app/files/static/6152430", // Anime13
      "https://files.idyllic.app/files/static/6152431", // Anime14
      "https://files.idyllic.app/files/static/6152432", // Anime15
      "https://files.idyllic.app/files/static/6152545", // Anime16
      "https://files.idyllic.app/files/static/6157924", // Anime17
    ],
  },
  architecture: {
    images: [
      "https://files.idyllic.app/files/static/6124495", // Arch1
      "https://files.idyllic.app/files/static/6124497", // Arch2
      "https://files.idyllic.app/files/static/6124499", // Arch3
      "https://files.idyllic.app/files/static/6124502", // Arch4
      "https://files.idyllic.app/files/static/6124503", // Arch5
      "https://files.idyllic.app/files/static/6124504", // Arch6
      "https://files.idyllic.app/files/static/6124507", // Arch7
      "https://files.idyllic.app/files/static/6124509", // Arch8
      "https://files.idyllic.app/files/static/6124510", // Arch9
      "https://files.idyllic.app/files/static/6152546", // arch11
      "https://files.idyllic.app/files/static/6152547", // arch12
      "https://files.idyllic.app/files/static/6152548", // arch13
      "https://files.idyllic.app/files/static/6152549", // arch14
      "https://files.idyllic.app/files/static/6152550", // arch15
      "https://files.idyllic.app/files/static/6157925", // arch16
    ],
  },
  cars: {
    images: [
      "https://files.idyllic.app/files/static/6124514", // car1
      "https://files.idyllic.app/files/static/6124516", // car2
      "https://files.idyllic.app/files/static/6124520", // car3
      "https://files.idyllic.app/files/static/6124521", // car4
      "https://files.idyllic.app/files/static/6124523", // car5
      "https://files.idyllic.app/files/static/6124522", // car6
      "https://files.idyllic.app/files/static/6124526", // car7
      "https://files.idyllic.app/files/static/6124528", // car8
      "https://files.idyllic.app/files/static/6124529", // car9
      "https://files.idyllic.app/files/static/6124531", // car10
      "https://files.idyllic.app/files/static/6124532", // car11
      "https://files.idyllic.app/files/static/6124533", // car12
      "https://files.idyllic.app/files/static/6152551", // car13
      "https://files.idyllic.app/files/static/6152552", // car14
      "https://files.idyllic.app/files/static/6152553", // car15
      "https://files.idyllic.app/files/static/6152554", // car16
      "https://files.idyllic.app/files/static/6152555", // car17
    ],
  },
  dnd: {
    images: [
      "https://files.idyllic.app/files/static/6124537", // DnD1
      "https://files.idyllic.app/files/static/6124545", // DnD2
      "https://files.idyllic.app/files/static/6124541", // DnD3
      "https://files.idyllic.app/files/static/6124547", // DnD4
      "https://files.idyllic.app/files/static/6124548", // DnD5
      "https://files.idyllic.app/files/static/6124550", // DnD6
      "https://files.idyllic.app/files/static/6124551", // DnD7
      "https://files.idyllic.app/files/static/6152556", // dnd9
      "https://files.idyllic.app/files/static/6158066", // dnd10
      "https://files.idyllic.app/files/static/6158068", // dnd11
      "https://files.idyllic.app/files/static/6158069", // dnd12
    ],
  },
  fantasy: {
    images: [
      "https://files.idyllic.app/files/static/6124554", // Fantasy1
      "https://files.idyllic.app/files/static/6124555", // Fantasy2
      "https://files.idyllic.app/files/static/6124556", // Fantasy3
      "https://files.idyllic.app/files/static/6124560", // Fantasy5
      "https://files.idyllic.app/files/static/6152557", // fantasy6
      "https://files.idyllic.app/files/static/6152562", // fantasy7
      "https://files.idyllic.app/files/static/6152563", // fantasy8
      "https://files.idyllic.app/files/static/6152568", // fantasy9
      "https://files.idyllic.app/files/static/6157930", // fantasy10
      "https://files.idyllic.app/files/static/6157935", // fantasy11
      "https://files.idyllic.app/files/static/6158120", // fantasy12
      "https://files.idyllic.app/files/static/6158121", // fantasy13
      "https://files.idyllic.app/files/static/6158122", // fantasy14
    ],
  },
  gooner: {
    images: [
      "https://files.idyllic.app/files/static/6124562", // Gooner1
      "https://files.idyllic.app/files/static/6124563", // Gooner2
      "https://files.idyllic.app/files/static/6124564", // Gooner3
      "https://files.idyllic.app/files/static/6124565", // Gooner4
      "https://files.idyllic.app/files/static/6124566", // Gooner5
      "https://files.idyllic.app/files/static/6124567", // Gooner6
      "https://files.idyllic.app/files/static/6124568", // Gooner7
      "https://files.idyllic.app/files/static/6124570", // Gooner8
      "https://files.idyllic.app/files/static/6124571", // Gooner9
      "https://files.idyllic.app/files/static/6124572", // Gooner10
      "https://files.idyllic.app/files/static/6152739", // Gooner11
      "https://files.idyllic.app/files/static/6152740", // Gooner12
    ],
  },
  horror: {
    images: [
      "https://files.idyllic.app/files/static/6124573", // Horror1
      "https://files.idyllic.app/files/static/6124576", // Horror3
      "https://files.idyllic.app/files/static/6124577", // Horror4
      "https://files.idyllic.app/files/static/6124578", // Horror5
      "https://files.idyllic.app/files/static/6124579", // Horror6
      "https://files.idyllic.app/files/static/6152569", // horror8
      "https://files.idyllic.app/files/static/6152574", // horror10
      "https://files.idyllic.app/files/static/6152575", // horror11
    ],
  },
  nature: {
    images: [
      "https://files.idyllic.app/files/static/6124582", // Nature1
      "https://files.idyllic.app/files/static/6124583", // Nature2
      "https://files.idyllic.app/files/static/6124584", // Nature3
      "https://files.idyllic.app/files/static/6124585", // Nature4
      "https://files.idyllic.app/files/static/6124586", // Nature5
      "https://files.idyllic.app/files/static/6124587", // Nature6
      "https://files.idyllic.app/files/static/6124589", // Nature7
      "https://files.idyllic.app/files/static/6124592", // Nature8
      "https://files.idyllic.app/files/static/6124594", // Nature9
      "https://files.idyllic.app/files/static/6152576", // nature10
      "https://files.idyllic.app/files/static/6152581", // nature11
      "https://files.idyllic.app/files/static/6157935", // nature12
      "https://files.idyllic.app/files/static/6157945", // nature13
      "https://files.idyllic.app/files/static/6157947", // nature14
    ],
  },
};

export const AVAILABLE_CATEGORIES = Object.keys(categoryMap);

let isSlideshowCreationInProgress = false;
let isAnalysisInProgress = false;
let lastSlideshowCreationTime = 0;
let lastAnalysisTime = 0;

const slideshowCache: Record<
  string,
  {
    images: string[];
    categories: string[];
    timestamp: number;
  }
> = {};

const analysisCache: Record<
  string,
  {
    categories: string[];
    timestamp: number;
  }
> = {};

export function getAllImages(): string[] {
  const allImages: string[] = [];

  Object.values(categoryMap).forEach((category) => {
    allImages.push(...category.images);
  });

  return allImages;
}

export function getAllImagesExcept(excludedCategories: string[]): string[] {
  const allImages: string[] = [];

  Object.entries(categoryMap).forEach(([category, data]) => {
    if (!excludedCategories.includes(category)) {
      allImages.push(...data.images);
    }
  });

  return allImages;
}

export async function analyzeCategoryWithLLM(
  currentPrompt: string,
  previousPrompts: string[] = []
): Promise<string[]> {
  if (typeof currentPrompt !== "string") {
    console.error("currentPrompt is not a string:", currentPrompt);
    currentPrompt = String(currentPrompt || "");
  }

  const cacheKey = `${currentPrompt}|${previousPrompts.slice(-10).join("|")}`;
  const now = Date.now();

  if (
    analysisCache[cacheKey] &&
    now - analysisCache[cacheKey].timestamp < 30000
  ) {
    return analysisCache[cacheKey].categories;
  }

  if (isAnalysisInProgress) {
    if (analysisCache[cacheKey]) {
      return analysisCache[cacheKey].categories;
    }
    return [];
  }

  isAnalysisInProgress = true;
  lastAnalysisTime = now;

  try {
    const recentPrompts = previousPrompts.slice(-10);

    const requestPayload = {
      currentPrompt,
      previousPrompts: recentPrompts,
      availableCategories: AVAILABLE_CATEGORIES,
    };

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/promptAnalyzer/analyze-prompt`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestPayload),
        signal: controller.signal,
      }
    );

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`);
    }

    const data = await response.json();
    const categories = data.categories || [];

    const validCategories = categories.filter((cat: string) =>
      AVAILABLE_CATEGORIES.includes(cat)
    );

    analysisCache[cacheKey] = {
      categories: validCategories,
      timestamp: now,
    };

    return validCategories;
  } catch (error) {
    console.error("🔍 Error analyzing category with LLM:", error);
    return [];
  } finally {
    isAnalysisInProgress = false;
  }
}

export async function createAISlideshowImageList(
  currentPrompt: string,
  previousPrompts: string[] = [],
  totalImages = 64
): Promise<{
  images: string[];
  categories: string[];
}> {
  const cacheKey = `${currentPrompt}|${previousPrompts.slice(-10).join("|")}`;
  const now = Date.now();

  if (now - lastSlideshowCreationTime < 10000) {
    if (
      slideshowCache[cacheKey] &&
      now - slideshowCache[cacheKey].timestamp < 30000
    ) {
      return {
        images: slideshowCache[cacheKey].images,
        categories: slideshowCache[cacheKey].categories,
      };
    }

    const allImages = getAllImagesExcept(["gooner"]);
    return {
      images: shuffleArray([...allImages]).slice(0, totalImages),
      categories: [],
    };
  }

  if (isSlideshowCreationInProgress) {
    const allImages = getAllImagesExcept(["gooner"]);
    return {
      images: shuffleArray([...allImages]).slice(0, totalImages),
      categories: [],
    };
  }

  isSlideshowCreationInProgress = true;
  lastSlideshowCreationTime = now;

  try {
    const matchedCategories = await analyzeCategoryWithLLM(
      currentPrompt,
      previousPrompts
    );

    const result = createSlideshowImageListFromCategories(
      matchedCategories,
      totalImages
    );

    slideshowCache[cacheKey] = {
      ...result,
      timestamp: now,
    };

    return result;
  } catch (error) {
    console.error("🖼️ Error creating AI slideshow:", error);

    const allImages = getAllImagesExcept(["gooner"]);
    return {
      images: shuffleArray([...allImages]).slice(0, totalImages),
      categories: [],
    };
  } finally {
    isSlideshowCreationInProgress = false;
  }
}

export function createSlideshowImageListFromCategories(
  matchedCategories: string[],
  totalImages = 64
): {
  images: string[];
  categories: string[];
} {
  if (!matchedCategories || matchedCategories.length === 0) {
    const allImages = getAllImagesExcept(["gooner"]);
    return {
      images: shuffleArray([...allImages]).slice(0, totalImages),
      categories: [],
    };
  }

  const categoryImagesArrays: string[][] = [];
  matchedCategories.forEach((category) => {
    if (categoryMap[category]) {
      const shuffledImages = shuffleArray([...categoryMap[category].images]);
      categoryImagesArrays.push(shuffledImages);
    }
  });

  if (categoryImagesArrays.length === 0) {
    const allImages = getAllImagesExcept(["gooner"]);
    return {
      images: shuffleArray([...allImages]).slice(0, totalImages),
      categories: [],
    };
  }

  const finalImages: string[] = [];

  for (let i = 0; i < totalImages; i++) {
    if (categoryImagesArrays.length === 1) {
      const categoryImages = categoryImagesArrays[0];
      const index = i % categoryImages.length;
      finalImages.push(categoryImages[index]);
    } else if (categoryImagesArrays.length >= 2) {
      const categoryIndex = i % 2;
      const categoryImages = categoryImagesArrays[categoryIndex];
      const imageIndex = Math.floor(i / 2) % categoryImages.length;
      finalImages.push(categoryImages[imageIndex]);
    }
  }

  return {
    images: finalImages,
    categories: matchedCategories,
  };
}

/**
 * Shuffles an array randomly
 */
function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
